import { _ as __assign } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { G as GroupChannelHeaderView } from '../../chunks/bundle-DsmBtJ5T.js';
import { b as useGroupChannelContext } from '../../chunks/bundle-BykuFiQC.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../chunks/bundle-Bse9fZMw.js';
import '../../chunks/bundle-B8a1gm3B.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../chunks/bundle-EMEHizdG.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-C6g3HNED.js';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CyIWMcD_.js';
import '../../ui/IconButton.js';
import '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-BSLHBsOu.js';
import '../../chunks/bundle-44j0QAmj.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-CHW7NXXK.js';
import '../../chunks/bundle--h0f5LUC.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../chunks/bundle-CxpAk_cb.js';

var GroupChannelHeader = function (props) {
    var context = useGroupChannelContext();
    return (React__default.createElement(GroupChannelHeaderView, __assign({}, props, context, { currentChannel: context.currentChannel })));
};

export { GroupChannelHeader, GroupChannelHeader as default };
//# sourceMappingURL=GroupChannelHeader.js.map
